const CrDetails = () => import('../screens/Compliance/CrDetails/CrDetails.vue');
const SamaIntegrationList = () =>
  import('../screens/Compliance/SamaIntegration/List/SamaIntegrationList.vue');

export default [
  {
    component: CrDetails,
    meta: {
      activeSidebarItemId: 'cr-details',
      authority: 'merchants:view_cr_details',
      pageTitle: 'Commercial Registration Details',
    },
    name: 'cr-details',
    path: '/cr-details',
  },
  {
    component: SamaIntegrationList,
    meta: {
      activeSidebarItemId: 'sama-integration',
      authority: 'sama_finance:view',
      pageTitle: 'Sama Integration',
    },
    name: 'sama-integration',
    path: '/sama-integration',
  },
];
